import { render, staticRenderFns } from "./idProofs.vue?vue&type=template&id=691489be&"
import script from "./idProofs.vue?vue&type=script&lang=js&"
export * from "./idProofs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports